import {CloseButton, Modal, ModalTitle,} from "react-bootstrap";
import ModalHeader from "react-bootstrap/ModalHeader";
import React, {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {EmployeesList} from "./EmployeesList";
import {faPeopleGroup, faWarehouse} from "@fortawesome/free-solid-svg-icons";
import {EmployeeDetails} from "./EmployeeDetails";
import {RREmployeeType} from "../../types/RREmployeeType";
import {EmployeeDelete} from "./EmployeeDelete";
import {DIALOG_OPTIONS} from "../../types/DialogOptionsType";
import {EmployeeAuth} from "./EmployeeAuth";
import {useAuthState} from "react-firebase-hooks/auth";
import {appAuth} from "../../../index";

export function EmployeesDialog({zIndex, show, onClose, onSelect}: DIALOG_OPTIONS) {

    const [viewMode, setViewMode] = useState<"VIEW_LIST" | "VIEW_ADD" | "VIEW_EDIT" | "VIEW_AUTH" | "VIEW_DELETE">('VIEW_LIST');
    const [editDocument, setEditDocument] = useState<RREmployeeType | null>(null);
    const [authDocument, setAuthDocument] = useState<RREmployeeType | null>(null);
    const [deleteDocument, setDeleteDocument] = useState<RREmployeeType | null>(null);
    const [addDocument, setAddDocument] = useState(false);
    const [currentUser, currentUserLoading] = useAuthState(appAuth);

    useEffect(() => {
        setViewMode(editDocument ? "VIEW_EDIT" : "VIEW_LIST");
    }, [editDocument])

    useEffect(() => {
        setViewMode(deleteDocument ? "VIEW_DELETE" : "VIEW_LIST");
    }, [deleteDocument])

    useEffect(() => {
        setViewMode(addDocument ? "VIEW_ADD" : "VIEW_LIST");
    }, [addDocument])

    useEffect(() => {
        setViewMode(authDocument ? "VIEW_AUTH" : "VIEW_LIST");
    }, [authDocument])

    return (
            <Modal show={show} size={"lg"} style={{zIndex: (zIndex + 1)}}>
                <ModalHeader>
                    <ModalTitle>
                        <FontAwesomeIcon icon={faPeopleGroup}/> Списък на служителите
                    </ModalTitle>
                    <CloseButton onClick={() => onClose(null)} />
                </ModalHeader>
                {
                    <EmployeesList onClose={onClose} isVisible={viewMode === "VIEW_LIST"}
                                   onSelect={onSelect}
                                   onAdd={() => setAddDocument(true)}
                                   onEdit={(doc: RREmployeeType ) => {
                                     setEditDocument(doc);
                                 }}
                                   onAuth={(doc: RREmployeeType ) => {
                                     setAuthDocument(doc);
                                 }}
                                   onDelete={(doc: RREmployeeType) => {
                                     setDeleteDocument(doc);
                                 }}
                    />
                }
                {
                    viewMode === "VIEW_EDIT" && editDocument &&
                    <EmployeeDetails employee={editDocument}
                                     onDone={() => {
                                      setEditDocument(null)
                                  }}/>
                }
                {
                    viewMode === "VIEW_AUTH" && authDocument &&
                    <EmployeeAuth employee={authDocument}
                                     onDone={() => {
                                      setAuthDocument(null)
                                  }}/>
                }
                {
                    viewMode === "VIEW_DELETE" && deleteDocument &&
                    <EmployeeDelete doc={deleteDocument} onDone={() => {
                        setDeleteDocument(null)
                    }}/>
                }
                {
                    viewMode === "VIEW_ADD" && addDocument &&
                    <EmployeeDetails employee={null}
                                     onDone={() => {
                                      setAddDocument(false)
                                  }}/>
                }

            </Modal>
    )
}
